import { Component, Input } from '@angular/core'
import { Store } from '@ngrx/store'
import { userActions } from '../../../../state/user/user.actions'

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent {
    constructor(private readonly store: Store) {}

    @Input() isSharedCase: boolean

    logout(): void {
        this.store.dispatch(userActions.startLogout())
    }
}
